export default {"src":"/_next/static/media/lead-contact.a0dd8ba9.svg","height":120,"width":435};